var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mdb-streak',{attrs:{"md":"","quote":_vm.quote,"by":_vm.by,"byClass":"grey-text font-weight-bold","quoteClass":"font-weight-bold","wrapperClass":"white"}}),_c('hr',{staticClass:"mb-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }